var React = require('react');

function ArrowLong (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M40.7071 8.92146C41.0976 8.53094 41.0976 7.89777 40.7071 7.50725L34.3431 1.14329C33.9526 0.752763 33.3195 0.752763 32.9289 1.14329C32.5384 1.53381 32.5384 2.16698 32.9289 2.5575L38.5858 8.21436L32.9289 13.8712C32.5384 14.2617 32.5384 14.8949 32.9289 15.2854C33.3195 15.6759 33.9526 15.6759 34.3431 15.2854L40.7071 8.92146ZM0 9.21436H40V7.21436H0V9.21436Z","fill":"#2D63D7"}));
}

ArrowLong.defaultProps = {"width":"41","height":"16","viewBox":"0 0 41 16","fill":"none"};

module.exports = ArrowLong;

ArrowLong.default = ArrowLong;
